import React, { useState } from 'react';
import { DeleteBookingLink } from '../../pages';
import { MimaToastUtil } from '../../components';
import constant from '../../utils/constant';
import { BookingController } from '../../controllers';
import { bookingStore } from '../../stores';

const DeleteBookingLinkContainer = ({closeModal}) => {
  const [loading, setLoading] = useState(false);

  const selectedLink = bookingStore.selectedBookingLink

  const confirmDelete = async() => {
    setLoading(true);
    const id = selectedLink._id
    const { status, errorMessage } = await BookingController.deleteBookingLink(id);

      if (status === constant.Success) {
        MimaToastUtil.success({
          message: constant.Success,
        });
        setLoading(false);
        closeModal();
      } else {
        setLoading(false);
        MimaToastUtil.error({ message: errorMessage });
      }
    }

  return (
    <DeleteBookingLink
      closeModal={closeModal}
      selectedLink={selectedLink}
      loading={loading}
      confirmDelete={confirmDelete}
    />
  )
}

export default DeleteBookingLinkContainer